// GPU grade: 'weak' or 'strong', from the WebGL renderer name. Integrated and mobile GPUs get the
// phone tier ladder (overview low, close-up medium): on Adelheid's Intel HD Graphics the high-tier
// bake shaders exceeded the driver's preemption timeout, the context was reset and the planet came
// back water-only (kernel: "i915 … Resetting rcs0 for preemption time out … GPU HANG", 2026-10-11;
// user: "i expected the game to switch to the weaker planets when gpu is … weak").
// `?gpu=weak` / `?gpu=strong` overrides for tests.
// Intel's older integrated parts (HD/UHD Graphics) are weak; Arc and Iris Xe handle the high tier
// (Lisbeth's "Intel Arc Graphics (MTL)" ran it all day, 2026-10-11) and are NOT matched.
const WEAK_GPU = /\bHD Graphics|UHD Graphics|Iris (?:Plus|Pro|Graphics)|Mali|Adreno|PowerVR|VideoCore|SwiftShader|llvmpipe|softpipe/i;

let cached = null;

export function gpuGrade() {
	if (cached) return cached;
	const forced = typeof location !== 'undefined' && new URLSearchParams(location.search).get('gpu');
	const gl = globalThis.game?.renderer?.getContext?.();
	if (!gl) return { grade: forced || 'strong', name: 'no renderer yet' }; // not cached: ask again later
	const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
	const name = String(debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER));
	const grade = forced === 'weak' || forced === 'strong' ? forced : (WEAK_GPU.test(name) ? 'weak' : 'strong');
	cached = { grade, name, real: WEAK_GPU.test(name) ? 'weak' : 'strong' }; // real = the chip itself, ignoring ?gpu=
	console.info(`[gpu-grade] ${grade}: ${name}${forced ? ' (forced)' : ''}`);
	return cached;
}
